export const SET_API_ERROR = 'set-checkout-api-error';
const setApiError = payload => ({ type: SET_API_ERROR, payload: payload || null });
export default setApiError;
